import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "oidc-react";
import { models, service, factories } from "powerbi-client";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import TimeoutPopup from "./TimeoutPopup";


const Report = ({ config, navigationData, language, setLanguage }) => {
  const auth = useAuth();

  console.log(auth);

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showTimeoutPopup, setShowTimeoutPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [expandedFolder, setExpandedFolder] = useState(null);

  const sidebarRef = useRef(null);
  const menuRef = useRef(null);
  const [decodeduseState, setDecodedToken] = useState(null);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  // useEffect(() => {
  //   if (auth?.userData?.access_token) {
  //     const token = auth.userData.access_token;
  //     const expiry = auth.userData.expires_at * 1000; // convert to ms

  //     sessionStorage.setItem("access_token", token);
  //     sessionStorage.setItem("token_expiry", expiry.toString());
  //     const decoded = jwtDecode(token);
  //     console.log("refresh token  - " + decoded)
  //    // setDecodedToken(decoded);
  //   }
  // }, [auth?.userData?.access_token]);
 // Toggle dropdown
  const handleUserMenuToggle = () => {
    setIsUserMenuOpen((prev) => !prev);
  };
 
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".user-menu")) {
        setIsUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  // Logout clears session and reloads page
  const handleLogout = (logOutUrl) => {
    
    localStorage.clear();
    sessionStorage.clear();

    auth.signOutRedirect({
      id_token_hint: auth.userData.id_token,
       post_logout_redirect_uri:logOutUrl
    });
  
 
  };
  
  const groupedData = navigationData?.NavigationDetails
    ?.filter((group) => group.IsVisible)
    ?.sort((a, b) => a.Order - b.Order);

  const handleArrowClick = () => {
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
      setTimeout(() => setIsSidebarVisible(false), 300);
    } else {
      setIsSidebarVisible(true);
      setTimeout(() => setIsSidebarOpen(true), 10);
    }
  };

  const handleMenuClick = async (reportId, ServerAPIUrl,xAPIId) => {

    const token = sessionStorage.getItem("access_token");
    const expiry = sessionStorage.getItem("token_expiry");


    if (!token || !expiry || Date.now() >= parseInt(expiry, 10)) {

      sessionStorage.clear();
      setShowTimeoutPopup(true);
      setLoading(false);
      return;
    }
    else {
      const refreshedUser = await auth.userManager.signinSilent();

      const refreshToken = refreshedUser.access_token;
      const refreshExpiry = refreshedUser.expires_at * 1000; // convert to ms

      sessionStorage.setItem("access_token", refreshToken);
      sessionStorage.setItem("token_expiry", refreshExpiry.toString());

    }

    setLoading(true);
    setSelectedId(reportId);

    try {
      // if (!token) {
      //   console.warn("User not authenticated.");
      //   setLoading(false);
      //   return;
      // }

      
     // const apiResponse = await axios.get(
     //   "https://pbi-reports-webapi-qa.apps.ose4-devtest-int.pwc.ca/PBIEmbed/ValidateToken",
     //   {
     //     headers: {
      //      Authorization: `Bearer ${token}`,
      //      "Content-Type": "application/json",
      //      "x-api-id":xAPIId
     //     },
     //   }).then(response => {
      //      console.log(response);
      //  });
       

      const decodedToken = jwtDecode(token);

      const ReportRequest = {
        reportId: reportId
      }

      const reportURL = `${ServerAPIUrl}`

      const response = await axios.post(
        reportURL,
        JSON.stringify(ReportRequest),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
			"x-api-id":xAPIId
          },
        }).then(response => {
          //console.log("Response data:", response.data);

          // Parse the string into a JSON object
          const parsedData = JSON.parse(response.data.response);

          // Extract and decode the embed URL
          const embedUrl = parsedData.embedUrl

          const embedConfig = {
            type: "report",
            tokenType: models.TokenType.Embed,
            accessToken: response.data.token,
            embedUrl: parsedData.embedUrl,
            id: response.data.reportId,
            settings: {
              background: models.BackgroundType.Transparent,
            },
          };
          //'da41f635-af1d-4320-81f7-feaac43786e7'
          const reportContainer = document.getElementById("reportContainer");

          const powerbiService = new service.Service(
            factories.hpmFactory,
            factories.wpmpFactory,
            factories.routerFactory
          );

          if (reportContainer.innerHTML !== "") {
            powerbiService.reset(reportContainer);
          }

          const report = powerbiService.embed(reportContainer, embedConfig);
          report.on("loaded", () => setLoading(false));
        })
        .catch(error => {
          const reportContainerExcep = document.getElementById("reportContainer");

          const powerbiServiceExcep = new service.Service(
            factories.hpmFactory,
            factories.wpmpFactory,
            factories.routerFactory
          );

          if (reportContainerExcep.innerHTML !== "") {
            powerbiServiceExcep.reset(reportContainerExcep);
          }

          setLoading(false);
          console.error("Error fetching report:", error);
        });

    } catch (error) {
      setLoading(false);
      console.error("Error embedding Power BI report:", error);

    }
  };


  if (!auth && !auth.userData) {
    return <div className="login-message">
      <p>{navigationData?.ErrorMessage || "Please login in portal"}</p>
    </div>
  }

  if (auth && auth.userData) {

    const token = auth.userData.access_token;
    const expiry = auth.userData.expires_at * 1000; // convert to ms

    const tokenSession = sessionStorage.getItem("access_token");
    const expirySession = sessionStorage.getItem("token_expiry");

    if (tokenSession == null && expirySession == null) {
      sessionStorage.setItem("access_token", token);
      sessionStorage.setItem("token_expiry", expiry.toString());
    }
    const decodedToken = jwtDecode(token);
    
    const isMatch = config.ValidEmployeeType.some(
      (item) => item.toLowerCase() === decodedToken.employeeType.toLowerCase()
    );
  let scope = false;
    if(isMatch && decodedToken != null && decodedToken.scope != null){
      scope =  decodedToken.scope.toLowerCase().includes(config.AccessGroup.toLowerCase());
    }
  
    if (scope) {
      return (
        <div className="app-container">
          <header className="header">
            <div className="header-left">
              <div
                ref={menuRef}
                className={`menu-icon ${isSidebarOpen ? "open" : ""}`}
                onClick={handleArrowClick}
              >
                <span></span><span></span><span></span>
              </div>
              <img
                src={navigationData?.Logo}
                alt="Logo"
                className="header-logo"
              />
            </div>
            <div className="header-center">
              <h1 className="header-title">{navigationData?.ReportTitle}</h1>
            </div>

            <div className="header-right">
            <div className="user-menu">
              <span className="username" onClick={handleUserMenuToggle}>
                {decodedToken?.name} ▼
              </span>
                  {isUserMenuOpen && (
                    <div className="user-dropdown">
                      <div className="dropdown-item" onClick={() => handleLogout(config.logoutRedirect)}>
                        Logout
                      </div>
                    </div>
                  )}
              </div>
              <div className="language-toggle" onClick={() => setLanguage(language === "en" ? "fr" : "en")}>
                <div className={`language-option ${language === "en" ? "active" : "inactive"}`}>En</div>
                <div className={`language-option ${language === "fr" ? "active" : "inactive"}`}>Fr</div>
              </div>
            </div>
          </header>

          {isSidebarVisible && (
            <div className={`sidebar ${isSidebarOpen ? "open" : ""}`} ref={sidebarRef}>
              <div className="sidebar-content">
                <div className="dropdown-options">
                  {groupedData?.map((group, i) => (
                    <div key={i} className="folder-block">
                      <div
                        className="folder-name"
                        onClick={() =>
                          setExpandedFolder(expandedFolder === group.Group ? null : group.Group)
                        }
                      >
                        <span className="folder-text">{group.Group}</span>
                        <span className={`folder-icon ${expandedFolder === group.Group ? "open" : ""}`}>
                          {expandedFolder === group.Group ? "−" : "+"}
                        </span>
                      </div>
                      {expandedFolder === group.Group &&
                        group.Reports?.filter(r => r.IsVisible)
                          .sort((a, b) => a.Order - b.Order)
                          .map(file => (
                            <div
                              key={file.ReportId}
                              className={`dropdown-option ${selectedId === file.ReportId ? "selected" : ""}`}
                              onClick={() => handleMenuClick(file.ReportId, config.ServerAPIUrl,config.XAPIID)}
                              title={file.ReportDescription}
                            >
                              {file.ReportName}
                            </div>
                          ))}
                    </div>
                  ))}
                </div>
              </div>
              <div className="sidebar-footer-text" dangerouslySetInnerHTML={{ __html: navigationData?.FooterText }} />
            </div>
          )}

          {loading && <div className="spinner-overlay"><div className="spinner" /></div>}
          <div id="reportContainer" className={`main-content ${isSidebarOpen ? "shrink" : ""}`} />

          {/* Popup modal */}
          {/* <TimeoutPopup
            show={showTimeoutPopup}
            Message={navigationData.TimeoutMessage}
            headerMessage={navigationData.TimeoutHeader}
            onRefresh={() =>
            (
              
              window.location.replace(config.RedirectUrl))
            }
          /> */}

          <TimeoutPopup
            show={showTimeoutPopup}
            Message={navigationData?.TimeoutMessage}
            headerMessage={navigationData?.TimeoutHeader}
            onRefresh={async () => {
              try {

                if (auth && auth.userManager) {
                  const { userManager } = auth;
                
                  if (typeof userManager.removeUser === "function") {
                    const result = userManager.removeUser();
                    if (result && typeof result.then === "function") {
                      await result;
                    }
                  }
                
                  sessionStorage.clear();
                
                  if (typeof userManager.signoutRedirect === "function") {
                    const result = userManager.signoutRedirect({
                      prompt: "login",
                      post_logout_redirect_uri: config.RedirectUrl
                    });
                  
                    if (result && typeof result.then === "function") {
                      await result;
                    }
                  }
                }
                
              } catch (err) {
                console.error("Logout failed:", err);

                // fallback: just reload
                //window.location.replace(config.RedirectUrl);
              }
            }}
          />

        </div>
      );
    }
    else {
      return (
        <div className="app-container">
          <header className="header">
            <div className="header-left">
              <img
                src={navigationData?.Logo}
                alt="Logo"
                className="header-logo"
              />
            </div>
            <div className="header-center">
              <h1 className="header-title">{navigationData?.ReportTitle}</h1>
            </div>

            <div className="header-right">

              <div className="user-name">
                {decodedToken?.name}
              </div>


              <div className="language-toggle" onClick={() => setLanguage(language === "en" ? "fr" : "en")}>
                <div className={`language-option ${language === "en" ? "active" : "inactive"}`}>En</div>
                <div className={`language-option ${language === "fr" ? "active" : "inactive"}`}>Fr</div>
              </div>
            </div>
          </header>

          <div className="not-valid">
            <p>You are not authorized to view reports.</p>
          </div>
        </div>
      );
    }
  }
};


export default Report;
